import { connect } from "react-redux";
import { useStore } from "react-redux";
import { favoriteAddApi } from "../../const"
import useMedia from "use-media";
import common from "../../resources/js/common/common";
import { Button } from "../atoms/button";
import { ModalClose } from "../atoms/modalClose";
import "../../resources/css/search/search.css";

const ConfirmationDialog = (props) => {
    const { login, course, detailCondition, startTime, state, onClickOpenConfirm, onClickOpenComplete } = props;
    const store = useStore();
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    // 確認ダイアログから完了ダイアログへ
    const DialogChenge = () => {

        const courseArray = [];
        course.forEach((data) => {
            if (data.checked === true) courseArray.push(data.id);
        });

        const detailArray = [];
        detailCondition.forEach((data) => {
            if (data.checked === true) detailArray.push(data.id);
        });

        const startTimeArray = [];
        startTime.forEach((data) => {
            if (data.checked === true) startTimeArray.push(data.id);
        });

        // リクエスト情報設定
        const condition = {
            golfCourseId: courseArray,
            teeTime: startTimeArray,
            detail: detailArray,
        };
        const req = {
            userid: login.memberCode,
            condition: JSON.stringify(condition)
        };

        common.doPost(favoriteAddApi, req, afterFavoriteAdd,onClickOpenConfirm);

    };
    const afterFavoriteAdd = (res) => {
        console.log(res);
        onClickOpenConfirm();
        onClickOpenComplete();
    }

    return (
        <div style={state ? style.popupIsShow : style.popup}>
            <div style={useMediaFlag ? style.popupInnerMedia : style.popupInner}>
            <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={onClickOpenConfirm}/>
                <h4 style={style.popupInnerText}>検索条件の保存</h4>
                <div style={style.title}>検索条件をお気に入りに登録しますか？</div>
                <div style={style.btnArea}>
                    <Button buttonText="はい" className="btnYesNo" onClick={DialogChenge} />
                    <Button buttonText="いいえ" className="btnYesNo" onClick={onClickOpenConfirm} />
                </div>
            </div>
            <div style={style.blackBackground} id="js-black-bg"></div>
        </div>
    );
};

const style = {
    popup: {
        position: "fixed",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        zIndex: "9999",
        opacity: "0",
        visibility: "hidden",
        transition: ".6s",
    },
    popupIsShow: {
        position: "fixed",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        zIndex: "9999",
        opacity: "1",
        visibility: "visible",
        transition: ".6s",
    },
    popupInner: {
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        width: "45%",
        backgroundColor: "#fff",
        zIndex: "2",
        height:"30%",
    },
    popupInnerMedia:{
        position: "absolute",
        left: "0%",
        bottom: "0%",
        // transform: "translate(-50%, -50%)",
        width: "100%",
        backgroundColor: "#fff",
        zIndex: "2",
        height:"40%"
    },
    blackBackground: {
        position: "absolute",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, .8)",
        zIndex: "1",
    },
    popupInnerText: {
        width: "100%",
        textAlign: "center",
        letterSpacing:1,
    },
    
    title:{
        textAlign:'center',
        paddingTop: 20,
        fontSize: 17,
        letterSpacing: 1,
    },
    btnArea:{
        display:"flex",
        justifyContent:'center',
        margin:"5% 5% 5% 5%",
    }
}

const mapStateToProps = (state) => {
    return {
        login: state.login,
        course: state.course,
        detailCondition: state.detailCondition,
        startTime: state.startTime,
    };
};

export default connect(mapStateToProps, null)(ConfirmationDialog);